export const BY_TASK = 'by-task';
export const BY_PART = 'by-part';

export const ASSISTANT_ENABLED = 'enabled';
export const ASSISTANT_DISABLED = 'disabled';



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/config/modularized.config.ts